<template>
  <div v-if="model" class="p-ml-2 p-d-flex p-ai-center">
    <LGAvatar :avatar="model.imagem" :tamanho="35" />
    <div class="p-ml-2 p-d-flex p-flex-column p-text-truncate">
      <span class="lg-aa-texto--secundario p-text-truncate p-text-bold">
        {{ model.titulo }}
      </span>
      <span class="lg-aa-texto--secundario p-text-truncate lg-aa-font-size--12">
        {{ model.subtitulo }}
      </span>
    </div>
  </div>
</template>

<script>
import LGAvatar from 'lg-vue-components/avatar';

export default {
  components: {
    LGAvatar,
  },
  props: {
    model: {
      type: Object,
      default: null,
    },
  },
};
</script>
